// src/services/api/index.ts

// Import services first
import { authService } from './auth.service';
import { projectsService } from './projects.service';
import { tasksService } from './tasks.service';
import { activityTypesService } from './activityTypes.service';
import { timeEntriesService } from './timeEntries.service';
import { usersService } from './users.service';
import { reportsService } from './reports.service';

// Export all services for easy importing
export { authService } from './auth.service';
export { projectsService } from './projects.service';
export { tasksService } from './tasks.service';
export { activityTypesService } from './activityTypes.service';
export { timeEntriesService } from './timeEntries.service';
export { usersService } from './users.service';
export { reportsService } from './reports.service';

// Export types
export * from './types';

// Export client and config
export { apiClient } from './client';
export { apiConfig, endpoints } from './config';

// Main API service that combines all services
export class ApiService {
  auth = authService;
  projects = projectsService;
  tasks = tasksService;
  activityTypes = activityTypesService;
  timeEntries = timeEntriesService;
  users = usersService;
  reports = reportsService;

  // Initialize the API service
  initialize() {
    // Set up auth token if available
    const hasValidToken = this.auth.initializeAuth();
    
    // Set up request interceptors for token refresh
    this.setupTokenRefreshInterceptor();
    
    return hasValidToken;
  }

  private setupTokenRefreshInterceptor() {
    // This would be called before each request to ensure valid token
    // For now, we'll handle it manually in components
    // In a real implementation, you might want to intercept requests
  }

  // Utility methods
  async ensureAuthenticated(): Promise<boolean> {
    return this.auth.ensureValidToken();
  }

  getCurrentToken(): string | null {
    // SECURITY: Tokens are now in HTTP-only cookies, cannot be accessed from JS
    // Return a placeholder if session is valid, null otherwise
    return this.auth.isTokenExpired() ? null : 'cookie-based';
  }

  isAuthenticated(): boolean {
    return !this.auth.isTokenExpired();
  }
}

// Export singleton instance
export const apiService = new ApiService();

// Initialize on import
apiService.initialize();
